<template>
    <div id="main">
        <Navbar/>
        <HomePage/>
        <Welcome/>
        <Commission/>
        <WhyUs/>
        <Testimonials/>
        <GetInTouch/>
        <Footer isBackgroundImage="true"/>
    </div>
</template>

<script>
    import Navbar from "./Navbar";
    import HomePage from "./HomePage";
    import Welcome from "./Welcome";
    import Commission from "./Commission";
    import WhyUs from "./WhyUs";
    import GetInTouch from "./GetInTouch";
    import Testimonials from "./Testimonials";
    import Footer from "./Footer";
    import {doScroll} from '../assets/js/scroll';
    import { mapActions } from 'vuex';

    export default {
        name: "Main",
        components: {
            Navbar,
            HomePage,
            Welcome,
            Commission,
            Testimonials,
            WhyUs,
            GetInTouch,
            Footer
        },
        methods: {
            ...mapActions([
                'setActiveTab',
            ]),
            doScroll
        },
        mounted: function () {
            if(this.$route.path === '/' && this.$route.query.id !== undefined) {
                setTimeout(() => {
                    this.doScroll(this.$route.query.id, false);
                    this.setActiveTab(this.$route.query.id);
                }, 500)
            }
        }
    }
</script>

<style scoped>

</style>